<template>
    <div class="loading" v-if="isLoading">
      <div class="loading_pic">
        <img src="@/assets/loading.png">
      </div>
    </div>
  </template>
  
  <script>
import { mapState } from 'vuex';
  export default {
  computed: {
    ...mapState(['isLoading'])
  },
    data() {
      return {
      };
    },
    created() {
    },
    methods:{
    }
  };
  </script>
  
  <style lang="scss" scoped>
  
.loading {
  width: 100%;
  height: 100vh;
  position: fixed;
  z-index: 99;
  background: rgba(0,0,0,0.6);
}
.loading_pic {
  width: 50px;
  height: 50px;
  animation: van-rotate .8s linear infinite;
  vertical-align: middle;
  animation-duration: 2s;
  position: absolute;
  top: 45%;
  left: calc(50% - 25px);
}
.loading_pic img {
  width: 100%;
  height: 100%;
}
  </style>


// WEBPACK FOOTER //
// src/components/loading.vue